import {
	SET_SELECTED_TRIM_DATA,
	SET_SELECTED_TRIM_COLOR_DATA,
	SET_SELECTED_TRIM_PACKAGE_DATA
} from '../actions/types';

export default function selectedTrimData(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_SELECTED_TRIM_DATA:
				return action.payload;
			case SET_SELECTED_TRIM_COLOR_DATA:
				return {
					...state,
					colors: action.payload
				};
			case SET_SELECTED_TRIM_PACKAGE_DATA:
				return {
					...state,
					packages: action.payload
				};
			// no default
		}
	}

	return state;
}
